import { useLocation } from 'react-router-dom';

/**
 * Hook that derives the screen name from the current route.
 * Automatically extracts screen from path segments for maximum simplicity.
 *
 * @returns The screen name for tracking, or undefined if route not recognized
 */
export const useScreenFromRoute = () => {
  const {
    pathname
  } = useLocation();

  // For /internal-development/* routes, use the segment after internal-development
  if (pathname.startsWith('/internal-development/')) {
    return pathname.replace('/internal-development/', '');
  }
  return undefined;
};